<template>
	<editor-product :item-id="itemId" />
</template>
<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		onBeforeMount,
	} from '@vue/composition-api';
	import EditorProduct from '@/components/product/EditorProduct';

	export default defineComponent({
		name: 'EditorProductModify',
		components: {
			EditorProduct,
		},
		setup(_, { root }) {
			const { $route: route } = root;
			const state = reactive({
				itemId: null,
			});

			const mutations = {
				setItemId: id => {
					state.itemId = id;
				},
			};

			onBeforeMount(() => {
				mutations.setItemId(route.params.productId);
			});

			return {
				...toRefs(state),
			};
		},
	});
</script>
<style lang="scss" scoped></style>
